<template>
  <div>
    <h6 class="mt-2">Add Discount :</h6>
    <div class="discount-container">
      <div class="discount-pax-item">
        <div class="form-group">
          <label for="">Adult :</label>
          <input v-model.number="discountComp.adult" type="text" placeholder="Amount" v-input-type="'number'" class="form-control form-control" />
        </div>
      </div>
      <div class="discount-pax-item">
        <div class="form-group">
          <label for="">CWB :</label>
          <input v-model.number="discountComp.cwb" type="text" placeholder="Amount" v-input-type="'number'" class="form-control form-control" />
        </div>
      </div>
      <div class="discount-pax-item">
        <div class="form-group">
          <label for="">CNB1 :</label>
          <input v-model.number="discountComp.cnb" type="text" placeholder="Amount" v-input-type="'number'" class="form-control form-control" />
        </div>
      </div>
      <div class="discount-pax-item">
        <div class="form-group">
          <label for="">CNB2 :</label>
          <input v-model.number="discountComp.cnb2" type="text" placeholder="Amount" v-input-type="'number'" class="form-control form-control" />
        </div>
      </div>

      <div class="discount-pax-item">
        <div class="form-group">
          <label for="">Infant :</label>
          <input v-model.number="discountComp.infant" type="text" placeholder="Amount" v-input-type="'number'" class="form-control form-control" />
        </div>
      </div>
      <div class="discount-pax-item button">
        <button @click.prevent="handleOnSave" :class="{ loading: updatingDiscount }" :disabled="CheckSaveVales || updatingDiscount" class="btn btn-info">Save</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "AddDiscount",
  props: {
    CheckSaveVales: { type: Boolean },
    discount: { type: Object }
  },
  computed: {
    ...mapGetters(["updatingDiscount"]),
    discountComp() {
      return this.discount;
    }
  },
  methods: {
    handleOnSave() {
      this.$emit("handleOnSave");
    }
  }
};
</script>

<style scoped>
.discount-container {
  display: flex;
  gap: 15px;
}

.discount-container .form-group {
  margin-bottom: 0;
}

.discount-container .form-group label {
  font-weight: 600;
  margin-bottom: 5px;
}

.discount-container .discount-pax-item.button {
  display: flex;
  align-self: flex-end;
}

.discount-container .discount-pax-item.button button {
  width: 80px;
  border-radius: 0;
}

.submit-btn {
  position: relative;
  transition: 0.7s all;
}
.submit-btn.loading {
  width: 80px;
  text-align: left;
  padding-left: 10px !important;
  padding-right: 5px !important;
}
.data-loader {
  position: absolute;
  top: 2px;
  right: -2px;
}
.data-loader >>> .lds-spinner {
  height: 0px;
  width: 0px;
  display: unset;
  position: absolute;
  right: 50px;
  top: -18px;
}

.data-loader >>> .lds-spinner div:after {
  content: " ";
  display: block;
  position: absolute;
  top: 23px;
  left: 31px;
  width: 2px;
  height: 6px;
  border-radius: 20%;
  background: black;
}
</style>
